module.exports = __webpack_public_path__ + "img/373.67ed8780.png";